export const formatPrice = (p)=>{
    if (p == null) return '';
    const n = Number(p);
    if (!isNaN(n)) {
        if (Number.isInteger(n) && Math.abs(n) > 100) return `$${(n / 100).toFixed(2)}`;
        return `$${n.toFixed(2)}`;
    }
    return String(p);
};
